//* Import necessary modules
import React from "react";

//* Import necessary components
import { Modal, Button } from "react-bootstrap";

export interface QuestionModalProps {
  show: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

/**
 * QuestionModal component displays a modal dialog to inform the user that the question is already in use
 * and asks if they want to create a new one with the same information.
 *
 * @param {boolean} show - Determines whether the modal is visible or not.
 * @param {() => void} onConfirm - Callback function to handle the confirmation action.
 * @param {() => void} onCancel - Callback function to handle the cancellation action.
 *
 * @returns {JSX.Element} The rendered modal component.
 */
const QuestionModal: React.FC<QuestionModalProps> = ({
  show,
  onConfirm,
  onCancel,
}) => {
  return (
    <Modal
      show={show}
      onHide={onCancel}
      centered
      data-testId="mock-question-exist-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title>Questão em uso</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          Esta questão está sendo utilizada. Deseja criar outra com as mesmas
          informações?
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onCancel}>
          Cancelar
        </Button>
        <Button variant="primary" onClick={onConfirm}>
          Sim, criar nova
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default QuestionModal;
